var map = {
	"./15_happy.mp3": "348b",
	"./16_sad.mp3": "c9fa",
	"./17_calm.mp3": "c4a3",
	"./18_angry.mp3": "3d60",
	"./19_sleepy.mp3": "fd0f",
	"./21_scared.mp3": "942c",
	"./M_Brilliant.mp3": "f4ea",
	"./M_Excellent.mp3": "9c98",
	"./M_Fantastic.mp3": "68c1",
	"./M_Great.mp3": "bfdb",
	"./M_Perfect.mp3": "3f97",
	"./M_Think again.mp3": "1130",
	"./M_Try again.mp3": "194a",
	"./M_Very good.mp3": "ff73",
	"./M_Well done.mp3": "1621",
	"./M_Work harder.mp3": "348c",
	"./click.mp3": "1d15",
	"./false.mp3": "890b",
	"./true.mp3": "5439"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51f0";